// libraries.
import { useEffect, useState } from "react";

// components.
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
} from "@shared/Inputs/Dropdown";
import { CheckboxItem } from "@shared/Inputs/Dropdown/components/CheckboxItem";

// hooks.
import { useModuleInventoryList } from "../../../inventoryList-slice/inventory.hook";

// utils.
import { checkOptions } from "../../../utils";

// styles.
import { WrapperInventoryFilters } from "./styles";

export const AlertsFilter = () => {
  const { updateAlertOptions } = useModuleInventoryList();
  const initialSelectedOptions = checkOptions.map((option) => option.value);
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    initialSelectedOptions,
  );

  const handleCheckboxChange = (value: string) => {
    setSelectedOptions((prevSelectedOpts) => {
      const isAllSelected = prevSelectedOpts.includes("selectAll");
      const isSelected = prevSelectedOpts.includes(value);

      if (value === "selectAll") {
        return isAllSelected ? [] : checkOptions.map((option) => option.value);
      }
      if (isSelected && prevSelectedOpts.length === checkOptions.length) {
        return prevSelectedOpts.filter(
          (option) => option !== value && option !== "selectAll",
        );
      }

      const updatedOptions = isSelected
        ? prevSelectedOpts.filter((option) => option !== value)
        : [...prevSelectedOpts, value];

      const optionsSelected = checkOptions
        .filter((option) => option.value !== "selectAll")
        .every((option) => updatedOptions.includes(option.value));

      return optionsSelected
        ? [...updatedOptions, "selectAll"]
        : updatedOptions;
    });
  };

  useEffect(() => {
    const hasSelectAll = selectedOptions.includes("selectAll");
    if (hasSelectAll) {
      const updatedOptions = selectedOptions.filter(
        (option) => option !== "selectAll",
      );
      updateAlertOptions(updatedOptions.join(","));
    } else {
      updateAlertOptions(selectedOptions.join(","));
    }
  }, [selectedOptions, updateAlertOptions]);

  const defaultOption = {
    label: "Tipo de Alerta",
    value: "alertFilter",
  };

  return (
    <WrapperInventoryFilters>
      <Dropdown value={defaultOption}>
        <DropdownToggle
          style={{
            background: "white",
            border: "1px solid #949494",
            color: "black",
          }}
          className="filter-toggle"
          id="dropdownAlertFilter"
          showArrow
        />
        {selectedOptions.length > 0 && (
          <span className="counter">{selectedOptions.length}</span>
        )}
        <DropdownMenu>
          {checkOptions.map((option) => (
            <CheckboxItem
              className="filter-check"
              key={option.value}
              id={option.label}
              label={option.label}
              checked={selectedOptions.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
            />
          ))}
        </DropdownMenu>
      </Dropdown>
    </WrapperInventoryFilters>
  );
};
